<template>
  <div class="match-info-wrapper">
    <van-progress
      v-if="matchInfo.status === 'in'"
      :is-guard-member="isGuardMember"
      :offensive-score="offensiveScore"
      :guardScore="guardScore" />
    <score-board
      v-if="isShowBoard && matchInfo.status === 'in'"
      :is-guard-member="isGuardMember"
      :match-info="matchInfo" />
    <result
      v-if="isShowResult && matchInfo.status !== 'in'"
      :is-guard-member="isGuardMember"
      :match-info="matchInfo"
      @close="onResultClose" />
    <personage-grade
      v-if="isShowPersonage && matchInfo.status === 'in'"
      :is-guard-member="isGuardMember"
      :match-info="matchInfo" />
  </div>
</template>

<script>
import api from '@/api/graphql/match';
import utils from '@/services/utils';
import Progress from './Progress.vue';
import ScoreBoard from './Scoreboard.vue';
import PersonageGrade from './PersonageGrade.vue';
import Result from './Result.vue';
import { LOOP } from './const';

export default {
  components: {
    VanProgress: Progress,
    ScoreBoard,
    Result,
    PersonageGrade,
  },
  props: {
    isShowBoard: {
      type: Boolean,
      default: false,
    },
    isShowPersonage: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isGuardMember() {
      const { id } = utils.storage('account');
      return utils.Array.exist(this.matchInfo.guard, { id }, 'id');
    },
  },
  data() {
    return {
      timer: null,
      checkTimer: null,
      matchInfo: {
        guard: [],
        offensive: [],
      },
      guardScore: 0,
      offensiveScore: 0,
      isShowResult: false,
    };
  },
  created() {
    this.LoopCheckEvent();
  },
  beforeDestroy() {
    clearTimeout(this.timer);
    clearInterval(this.checkTimer);
  },
  methods: {
    fetchMatchInfo(id) {
      api.matchInfo({
        id,
      }).then(({ matchInfo }) => {
        this.matchInfo = matchInfo;
        this.offensiveScore = matchInfo.offensiveScore;
        this.guardScore = matchInfo.guardScore;

        if (matchInfo.status === 'in') {
          this.LoopEvent(id);
        } else {
          this.isShowResult = true;
          utils.storage('match_info', null);
          // 比赛结束后 重启定时检测比赛
          clearTimeout(this.timer);
          this.timer = null;
          this.LoopCheckEvent(id);
        }
      }).catch(() => {
        this.LoopEvent(id);
      });
    },
    LoopCheckEvent() {
      this.checkTimer = setInterval(() => {
        const matchInfo = utils.storage('match_info');
        if (matchInfo) {
          clearInterval(this.checkTimer);
          this.checkTimer = null;
          this.LoopEvent(matchInfo.match_id);
        }
      }, LOOP);
    },
    LoopEvent(id) {
      this.timer = setTimeout(() => {
        this.fetchMatchInfo(id);
      }, LOOP);
    },
    onResultClose() {
      this.isShowResult = false;
    },
  },
};
</script>
